import React from 'react';
import './Header.css';

const Header = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const openUrl = (url) => {
    window.open(url, '_blank');
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={() => scrollTo('overview')} style={{cursor:'pointer'}}>
            <h1>PolyLink</h1>
          </div>
          <nav className="nav">
            <button className="link" onClick={() => scrollTo('overview')}>Overview</button>
            <button className="link" onClick={() => scrollTo('research')}>Research</button>
            {/* <button className="link" onClick={() => scrollTo('hkust')}>@HKUST</button> */}
            {/* <button className="link" onClick={() => scrollTo('collaboration')}>Collaboration</button> */}
          </nav>
          <div className="cta">
            <button className="btn btn-secondary" onClick={() => openUrl('https://evan-25.gitbook.io/polylink')}>Docs</button>
            <button className="btn" onClick={() => openUrl('http://polylink.evan.cafe:9000/#/login')}>Join Network</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 